(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("SaveAsTemplateModal", SaveAsTemplateModal);

    SaveAsTemplateModal.$inject = ['$scope', 'onSave'];

    function SaveAsTemplateModal ($scope, onSave) {
        var self = this;

        self.nameIsRequired = false;

        self.save = function () {
            if (self.name) {
                delete self.nameIsRequired;
                onSave(self.name);
                self.close();
            } else {
                self.nameIsRequired = true;
            }
        };

        self.close = function () {
            $scope.$hide();
        };
    }

})();